module.exports = __webpack_public_path__ + "static/img/24.99f7754.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/3/24.png
// module id = dcrH
// module chunks = 0